import styled from 'styled-components';

export const Wrapper = styled.div`
	margin: 0 auto;
`;

export const Divider = styled.div<{
	isExtended: boolean;
}>`
	background: rgba(255, 255, 255, 0.8);
	height: 1px;
	width: ${p => (p.isExtended ? '100%' : '40px')};
	margin: 24px auto;
`;
